/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

export default function openLinkThroughIframe(uri: string) {
  window.parent.postMessage({
    message: "openExternalLink",
    link: uri
  }, API_TOKEN_RESOURCE);
}
